import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

export class GenericPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        super(_prizeData);
        services.logger.warning("Prize " + JSON.stringify(_prizeData) + " is not known by the orbit client");
    }
    public prizeString() {
        return "Unknown Prize"; // this._prizeData.prizeValue.toString();
    }
}
